<div
  class="dashboard-shell flex flex-col md:flex-row min-h-screen md:h-screen md:overflow-hidden"
  [attr.data-theme]="temaClaro() ? 'light' : 'dark'"
>
  <app-sidebar [totales]="totales()" [colapsado]="sidebarColapsado()" (cerrar)="cerrarSidebarMovil()" />

  @if (!sidebarColapsado()) {
    <div class="sidebar-backdrop md:hidden" (click)="cerrarSidebarMovil()"></div>
  }

  <div class="flex-1 flex flex-col min-w-0 md:min-h-0">
    <div class="dashboard-header flex flex-col md:flex-row md:items-center gap-3 px-4 md:px-6 py-3 md:py-4">
      <div class="flex items-center gap-3">
        <button
          type="button"
          class="icon-btn shrink-0"
          (click)="alternarSidebar()"
          [attr.aria-label]="sidebarColapsado() ? 'Mostrar panel lateral' : 'Ocultar panel lateral'"
        >
          @if (sidebarColapsado()) {
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M15 4v16" />
            </svg>
          } @else {
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="3" y="4" width="18" height="16" rx="2" />
              <path d="M9 4v16" />
            </svg>
          }
        </button>

        <div class="min-w-0">
          <h1 class="dashboard-title text-[15.5px] md:text-[16.5px] font-bold m-0 truncate">Productos capturados</h1>
          <div class="dashboard-subtitle text-[11px] md:text-xs truncate">Se actualiza en tiempo real mientras se captura en el piso de feria</div>
        </div>

        <button
          type="button"
          (click)="irACapturar()"
          class="capturar-btn-movil md:hidden ml-auto shrink-0 text-[11.5px] font-semibold px-3 py-2 rounded-lg text-white"
        >
          Capturar
        </button>
      </div>

      <label for="dashboard-busqueda" class="sr-only">Buscar producto o proveedor</label>
      <div class="search-wrap w-full md:w-auto md:ml-5 md:flex-1 md:max-w-[280px]">
        <input
          id="dashboard-busqueda"
          [ngModel]="busqueda()"
          (ngModelChange)="busqueda.set($event)"
          placeholder="Buscar producto o proveedor…"
          class="search-input w-full px-3 py-2 pr-9 text-[12.5px]"
        />
        <svg class="search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="11" cy="11" r="7" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </div>

      <div class="flex items-center gap-1.5 overflow-x-auto scroll-oscuro pb-0.5 md:pb-0" role="group" aria-label="Filtrar por capturador">
        <button
          type="button"
          (click)="filtroCapturador.set(null)"
          [class]="'icon-btn icon-btn--ancho shrink-0 text-[11px] font-bold h-8 ' + (filtroCapturador() === null ? 'activo' : '')"
          [attr.aria-pressed]="filtroCapturador() === null"
          title="Ver todos los capturadores"
        >
          Todos
        </button>
        @for (letra of capturadores; track letra) {
          <button
            type="button"
            (click)="cambiarFiltroCapturador(letra)"
            [class]="'icon-btn shrink-0 text-[12px] font-bold w-8 h-8 ' + (filtroCapturador() === letra ? 'activo' : '')"
            [attr.aria-pressed]="filtroCapturador() === letra"
          >
            {{ letra }}
          </button>
        }
      </div>

      <div class="flex items-center gap-2.5 md:ml-auto">
        @if (puedeCrearRegistro) {
          <button
            type="button"
            (click)="mostrarCrearRegistro.set(true)"
            class="icon-btn icon-btn--ancho shrink-0 whitespace-nowrap text-[12px] font-bold"
          >
            + Nuevo
          </button>
        }
        <button
          type="button"
          class="icon-btn shrink-0"
          (click)="alternarTema()"
          [attr.aria-label]="temaClaro() ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'"
        >
          @if (temaClaro()) {
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
            </svg>
          } @else {
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
            </svg>
          }
        </button>

        <button
          type="button"
          (click)="mostrarExport.set(true)"
          [disabled]="productos().length === 0"
          class="export-btn flex-1 md:flex-none flex items-center justify-center gap-2 text-[13px] font-semibold px-4 py-2.5 rounded-lg"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 15V3M6 9l6 6 6-6" />
            <path d="M5 21h14" />
          </svg>
          Exportar a PowerPoint
        </button>
      </div>
    </div>

    <div class="flex-1 flex min-h-0 flex-col md:flex-row">
      <div
        class="product-list-panel scroll-oscuro w-full md:w-[330px] shrink-0 border-b md:border-b-0 overflow-y-auto"
        [class.oculto-en-movil]="activoId() !== null"
      >
        @for (grupo of agrupados(); track grupo[0]) {
          <div class="p-3.5 pb-1">
            <div class="product-group-label font-mono text-[10.5px] uppercase tracking-wide px-1.5 pb-2">
              {{ etiquetaGrupo(grupo[0]) }}
            </div>
            @for (p of grupo[1]; track p.id) {
              <button
                type="button"
                (click)="activoId.set(p.id)"
                [class]="'product-item w-full text-left flex gap-2.5 items-center px-2.5 py-2.5 rounded-lg cursor-pointer mb-1 ' + (p.id === activoId() ? 'activo' : '')"
              >
                @if (fotoDeProducto(p); as foto) {
                  <app-foto-remota [url]="foto" alt="" className="w-10 h-10 rounded-md shrink-0 border border-[var(--border)] object-cover" />
                } @else {
                  <div class="w-10 h-10 rounded-md shrink-0 border border-[var(--border)]" [style.background]="fondoTela(p)"></div>
                }
                <div class="min-w-0 flex-1">
                  <div class="text-[12.5px] font-semibold truncate">{{ p.mueble }}</div>
                  <div class="product-item-sub text-[11px] truncate">
                    {{ ultimoSegmentoId(p.id) }} · FOB ${{ p.fob ?? '—' }} · {{ p.telas.length }} tela{{ p.telas.length !== 1 ? 's' : '' }}
                  </div>
                </div>
                <span class="status-dot shrink-0" [style.background]="estaListo(p) ? 'var(--success)' : 'var(--jamar-red)'"></span>
              </button>
            }
          </div>
        }
        @if (productos().length === 0) {
          <p class="p-4 text-[12.5px] product-item-sub">
            Sin capturas todavía. Ve a "Capturar producto" desde el menú.
          </p>
        }
      </div>

      @if (activo(); as act) {
        <div class="flex-1 min-w-0 flex flex-col">
          <button type="button" class="volver-lista md:hidden flex items-center gap-1.5 text-[12.5px] font-semibold px-4 pt-3" (click)="activoId.set(null)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="m15 18-6-6 6-6" />
            </svg>
            Volver a la lista
          </button>
          @for (n of [act.id]; track n) {
            <app-detalle-panel
              [producto]="act"
              [proveedorNombre]="nombreProveedor(act.proveedorCodigo)"
              [proveedorFotoTarjetaUrl]="fotoTarjetaProveedor(act.proveedorCodigo)"
              (guardado)="recargar()"
              (eliminado)="activoId.set(null); recargar()"
            />
          }
        </div>
      } @else {
        <div class="detail-empty oculto-en-movil flex-1 flex items-center justify-center text-sm">
          Selecciona un producto para ver el detalle.
        </div>
      }
    </div>
  </div>

  @if (mostrarExport()) {
    <app-export-modal [productos]="productos()" [proveedores]="proveedores()" (cerrar)="mostrarExport.set(false)" />
  }

  @if (mostrarCrearRegistro()) {
    <app-crear-registro-modal
      [proveedores]="proveedores()"
      (cerrar)="mostrarCrearRegistro.set(false)"
      (creado)="mostrarCrearRegistro.set(false); recargar()"
    />
  }
</div>
